/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaChevronDown } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../Context/AuthContext";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Select from 'react-select';
const provinces = {
    Dubai: "دبي",
    Ajman: "عجمان",
    Sharjah: "الشارقة",
    AbuDhabi: "أبوظبي",
    Fujairah: "الفجيرة",
    RasAlKhaimah: "رأس الخيمة",
    UmAlQuwain: "أم القيوين",
    AlAin: "العين"
};

const citiesByProvince = {
    Dubai: [
        { value: "BurDubai", labelEn: "Bur Dubai", labelAr: "بر دبي" },
        { value: "Deira", labelEn: "Deira", labelAr: "ديرة" },
        { value: "Dubai", labelEn: "Dubai", labelAr: "دبي" },
        { value: "Garhoud", labelEn: "Garhoud", labelAr: "القرهود" },
        { value: "HorlAlAnz", labelEn: "Horl Al Anz", labelAr: "هور العنز" },
        { value: "Karama", labelEn: "Karama", labelAr: "الكرامة" },
        { value: "Qusais", labelEn: "Qusais", labelAr: "القصيص" },
        { value: "DubaiInternetCity", labelEn: "Dubai Internet City", labelAr: "مدينة دبي للإنترنت" },
        { value: "Jumeirah", labelEn: "Jumeirah", labelAr: "جميرا" },
        { value: "Satwa", labelEn: "Satwa", labelAr: "السطوة" },
        { value: "TradeCentre", labelEn: "Trade Centre", labelAr: "مركز التجارة" },
        { value: "AlAweer", labelEn: "Al Aweer", labelAr: "العوير" },
        { value: "Mirdif", labelEn: "Mirdif", labelAr: "مردف" },
        { value: "Warsan", labelEn: "Warsan", labelAr: "ورسان" },
        { value: "JebalAli", labelEn: "Jebal Ali", labelAr: "جبل علي" },
        { value: "Hatta", labelEn: "Hatta", labelAr: "حتا" }
    ],
    Ajman: [
        { value: "AjmanCity", labelEn: "Ajman City", labelAr: "مدينة عجمان" },
        { value: "Rashidya", labelEn: "Rashidya", labelAr: "الراشدية" }
    ],
    Sharjah: [
        { value: "Sharjah", labelEn: "Sharjah", labelAr: "الشارقة" },
        { value: "Dhaid", labelEn: "Dhaid", labelAr: "الذيد" }
    ],
    AbuDhabi: [
        { value: "AbuDhabi", labelEn: "Abu Dhabi", labelAr: "أبوظبي" },
        { value: "Musaffah", labelEn: "Musaffah", labelAr: "مصفح" },
        { value: "Al Mafraq", labelEn: "Al Mafraq", labelAr: "المفرق" }
    ],
    AlAin: [
        { value: "AlAinCity", labelEn: "AlAin City", labelAr: "مدينة العين" }
    ],
    Fujairah: [
        { value: "DibaAlHesn", labelEn: "Diba Al Hesn", labelAr: "دبا الحصن" },
        { value: "HassanDibba", labelEn: "Hassan Dibba", labelAr: "حسن دبا" },
        { value: "Fujairah", labelEn: "Fujairah", labelAr: "الفجيرة" },
        { value: "Kalba", labelEn: "Kalba", labelAr: "كلباء" },
        { value: "KhawrFakkan", labelEn: "Khawr Fakkan", labelAr: "خورفكان" }
    ],
    RasAlKhaimah: [
        { value: "RasAlKhaimahCity", labelEn: "Ras Al Khaimah City", labelAr: "مدينة رأس الخيمة" }
    ],
    UmAlQuwain: [
        { value: "FalajAlMulla", labelEn: "Falaj Al Mulla", labelAr: "فلج المعلا" },
        { value: "UmmAlQuwain", labelEn: "Um Al Quiwan", labelAr: "أم القيوين" }
    ]
};

// UAE Bank IBAN validation

// UAE Bank validation - check if IBAN starts with AE and has valid length
const validateUaeBank = (iban) => {
    if (!iban || !iban.startsWith("AE") || iban.length !== 23) {
        return false;
    }
    return true;
};

const customStyles = {
    container: (provided) => ({
        ...provided,
        direction: 'rtl',
    }),
    control: (provided) => ({
        ...provided,
        textAlign: 'right',
        padding: '0',
        border: '1px solid #ccc',
        borderRadius: '0.375rem',
        boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1)',
    }),
    placeholder: (provided) => ({
        ...provided,
        textAlign: 'right',
        direction: 'rtl',
    }),
    singleValue: (provided) => ({
        ...provided,
        textAlign: 'right',
        direction: 'rtl',
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: '0',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
};

const apiUrl = process.env.REACT_APP_API_URL;
const PrefilledCityFlag = process.env.REACT_APP_REMOVE_PREFILLED_CITIES;
const PrefilledAddressFlag = process.env.REACT_APP_REMOVE_PREFILLED_ADDRESS;

export const RefundForm = () => {
    // const uaeIbanValidationSchema = Yup.string()
    //         .transform(value => value?.replace(/[-\s]/g, '')) // Removes dashes & spaces
    //         .matches(/^AE[0-9A-Z]{21}$/, 'invalid-iban-format') // UAE IBAN format: AE + 21 characters (total 23)
    //         .required(t('iban-required'))
    //         .test("remove-spaces", 'iban-no-spaces', (value) => !/\s/.test(value))
            // .transform(value => value.replace(/\s+/g, '')); // Removes spaces
    const location = useLocation();
    const {
        totalAmount,
        totalAmountWithTax,
        notRefundable,
        refundFee,
    } = location.state || {};
    const [provinceOptions, setProvinceOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showOtherFields, setShowOtherFields] = useState(false);
    const { t } = useTranslation();
    const { totalPrice, orderData, orderItems, setTotalPrice, setTotalQuantity, setOrderData, setOrderItems } = useAuth();
    const navigate = useNavigate();
    const paymentMethodIncludesCod = orderData.payment_method === 'Cash on Delivery (COD)';
    
    const validationSchema = Yup.object({
        firstName: Yup.string().required(t("first-name-required")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        secondName: Yup.string().required(t("second-name-required")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        email: Yup.string().email(t("invalid-email-format")).required(t("email-required")),
        iban: paymentMethodIncludesCod ? Yup.string()
        .transform(value => value?.replace(/[-\s]/g, '')) // Removes dashes & spaces
        .matches(/^AE[0-9A-Z]{21}$/, t('invalid-iban-format')) // UAE IBAN format: AE + 21 characters (total 23)
        .required(t('iban-required'))
        .test("remove-spaces", t('iban-no-spaces'), (value) => !/\s/.test(value))
        .transform(value => value.replace(/\s+/g, '')) : Yup.string(),
        phone: Yup.string()
        .matches(
            /^(\+971|971|0)?5[0-9]{8}$/,
            t("invalid-uae-phone")
            )
            .required(t("phone-required")),
            reason: Yup.string().required(t("reason-required")).test('not-a-url', t('cannotBeUrl'), value => {
                const trimmedValue = value?.trim();
                const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
                const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
                const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
                return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
            }),
        province: Yup.string().required(t("province-required")),
        city: Yup.string()
        .required(t("city-required"))
        .test("valid-city", t("invalid-city"), function (value) {
            const { province } = this.parent;
            if (!value || !province) return false;
            const provinceCities = citiesByProvince[province] || [];
            return provinceCities.some(city => city.value === value);
        }),
        address: Yup.string().required(t("address-required")).max(500, t("address-max-500")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        }),
        others: showOtherFields ? Yup.string().required(t("reason-required")).max(500, t("reason-max-500")).test('not-a-url', t('cannotBeUrl'), value => {
            const trimmedValue = value?.trim();
            const urlRegex = /^(https?:\/\/(?:www\.)?[^\s$.?#].[^\s]*$)/;
            const simpleUrlRegex = /^(?!\s*$)(\S+\.\S+|\S+\.\S+\.\S+)(?!\S)/;
            const invalidContentRegex = /(\S+\.\S+.*[^\s])$/;
            return !urlRegex.test(trimmedValue) && !simpleUrlRegex.test(trimmedValue) && !invalidContentRegex.test(trimmedValue);
        })
        : Yup.string()
    });
    
    useEffect(() => {
        const cachedOrderData = JSON.parse(localStorage.getItem('orderData'));
        const cachedOrderItems = JSON.parse(localStorage.getItem('orderItems'));
        const cachedTotalPrice = localStorage.getItem('totalPrice');
        const cachedTotalQuantity = localStorage.getItem('totalQuantity');
        
        if (cachedOrderData && cachedOrderItems) {
            setOrderData(cachedOrderData);
            setOrderItems(cachedOrderItems);
            setTotalPrice(cachedTotalPrice);
            setTotalQuantity(cachedTotalQuantity);
            
            formik.setValues({
                firstName: cachedOrderData?.Customer?.first_name || "",
                secondName: cachedOrderData?.Customer?.last_name || "",
                email: cachedOrderData?.Customer?.email || "",
                phone: "",
                reason: "",
                iban: "",
                province: "",
                city: PrefilledCityFlag ? "" : getCityKey(cachedOrderData?.Customer?.city || ""),
                address: PrefilledAddressFlag ? "" : cachedOrderData?.Customer?.address || ""
            });
            
            setProvinceOptions(
                Object.keys(provinces).map(key => ({
                    value: key,
                    label: provinces[key]
                }))
                );
            }
        }, []);
        
        const handleReasonChange = (event) => {
            const selectedReason = event.target.value;
        formik.setFieldValue('reason', selectedReason);
        setShowOtherFields(selectedReason === 'other');
    };

    const handleLoading = (value) => setLoading(value);

    const getCityKey = (arabicCityName) => {
        return Object.keys(cities).find(key => cities[key] === arabicCityName);
    };

    const formik = useFormik({
        initialValues: {
            firstName: orderData?.Customer?.first_name || "",
            secondName: orderData?.Customer?.last_name || "",
            email: orderData?.Customer?.email || "",
            reason: "",
            phone: "",
            province: "",
            iban: "",
            city: PrefilledCityFlag ? "" : cityOptions.find(option => option.value === orderData?.Customer?.city) || "",
            address: PrefilledAddressFlag ? "" : orderData?.Customer?.address || "",
            others: "",
        },
        validationSchema,
        onSubmit: async (values) => {
            // Validate UAE IBAN
            if (paymentMethodIncludesCod && !validateUaeBank(values.iban)) {
                toast.error(t("invalid-uae-bank"));
                return;
            }

            const returnItems = orderItems
                .filter(item => item.refund_quantity > 0)
                .map(item => ({
                    product_id: item.Product.id,
                    quantity: item.refund_quantity
                }));

            const payload = {
                payment_method: orderData?.payment_method,
                items: returnItems,
                refund_amount: (parseFloat((totalPrice - 0.01) * 100) / 100) - process.env.REACT_APP_REFUND_FEE > 0 ? parseFloat(((parseFloat((totalPrice - 0.01) * 100) / 100) - process.env.REACT_APP_REFUND_FEE).toFixed(2)) : 0,
                city: values.city,
                province: values.province,
                reason: values.reason === "other" ? values.others : values.reason,
                first_name: values.firstName,
                last_name: values.secondName,
                email: values.email,
                phone: values.phone,
                address: values.address,
                total_with_tax: totalAmountWithTax,
                total_refundable_amount: totalAmount,
                total_non_refundable_amount: notRefundable,
                return_fees: refundFee,
            };

            // Add IBAN if COD payment method
            if (values.iban) {
                payload.iban = values.iban;
                // UAE banks don't require bank_code in the same way as KSA
                // Only send IBAN which is sufficient for UAE banks
            }

            const token = localStorage.getItem('token');
            try {
                handleLoading(true);
                const response = await axios.post(
                    `${apiUrl}/refund-requests`,
                    payload,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        }
                    }
                );
                handleLoading(false);
                if (response?.data?.uuid) {
                    toast.success("successfully submitted the refund request");
                    setTotalPrice(0);
                    setTotalQuantity(0);
                    localStorage.removeItem('orderData');
                    localStorage.removeItem('orderItems');
                    localStorage.removeItem('totalPrice');
                    localStorage.removeItem('totalQuantity');
                    setTimeout(() => {
                        navigate(`/bank-info/confirmation/${response?.data?.uuid}`);
                    }, 1000);
                }
            } catch ({ response }) {
                handleLoading(false);
                toast.error(response?.data?.message);
            }
        },
    });

    return (
        <div className="flex justify-center items-start mt-12 p-4">
            <ToastContainer />
            <div className="w-full md:w-1/2 lg:w-1/3 bg-white p-6 rounded-lg shadow-lg">
                <form onSubmit={formik.handleSubmit} className="space-y-5">
                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("first-name")}
                        </label>
                        <input
                            type="text"
                            name="firstName"
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("first-name")}
                        />
                        {formik.touched.firstName && formik.errors.firstName ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.firstName}
                            </div>
                        ) : null}
                    </div>

                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("second-name")}
                        </label>
                        <input
                            type="text"
                            name="secondName"
                            value={formik.values.secondName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("second-name")}
                        />
                        {formik.touched.secondName && formik.errors.secondName ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.secondName}
                            </div>
                        ) : null}
                    </div>

                    {paymentMethodIncludesCod && (
                        <div className="relative">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end items-center gap-1">
                                {t("iban")}
                            </label>
                            <input
                                type="text"
                                name="iban"
                                value={formik.values.iban}
                                onChange={(e) => {
                                    const cleanedValue = e.target.value.replace(/[-\s]/g, '').toUpperCase();
                                    formik.setFieldValue('iban', cleanedValue);
                                }}
                                onBlur={formik.handleBlur}
                                className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                                placeholder={t("iban")}
                            />
                            {formik.touched.iban && formik.errors.iban ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.iban}
                                </div>
                            ) : null}
                            {orderData?.showIbanMessage && (
                                <div className="bg-yellow-100 text-yellow-800 text-xs rounded-lg px-3 py-2 right-0 bottom-full mb-1 shadow-md z-10 mt-2 border border-yellow-300">
                                    💡 {t("iban-message")}
                                </div>
                            )}
                            {formik.values.iban && !formik.errors.iban && formik.values.iban.startsWith('AE') && (
                                <div className="text-green-600 text-sm mt-2">
                                    ✓ {t("valid-uae-iban")}
                                </div>
                            )}
                        </div>
                    )}

                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("email")}
                        </label>
                        <input
                            type="email"
                            name="email"
                            value={formik.values.email}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("email")}
                        />
                        {formik.touched.email && formik.errors.email ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.email}
                            </div>
                        ) : null}
                    </div>

                    <div className="relative">
                        <label className="text-sm text-gray-600 mr-2 flex justify-end">
                            {t("phone")}
                        </label>
                        <input
                            type="phone"
                            name="phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            className="form-input w-full text-right placeholder-right border border-gray-300 p-2"
                            placeholder={t("phone")}
                        />
                        {formik.touched.phone && formik.errors.phone ? (
                            <div className="text-red-500 text-sm mt-1 text-right">
                                {formik.errors.phone}
                            </div>
                        ) : null}
                    </div>

                    <div className="flex flex-col items-end space-y-4">
                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("select-reason")}
                            </label>
                            <select
                                name="reason"
                                value={formik.values.reason}
                                onChange={handleReasonChange}
                                onBlur={formik.handleBlur}
                                className="form-select w-full text-right appearance-none pr-2 py-2 border border-gray-400"
                            >
                                <option value="" disabled>
                                    {t("select-reason")}
                                </option>
                                <option value="perfume didn't suite me">
                                    {t("perfume-didn't-suite-me")}
                                </option>
                                <option value="I'd like to try another perfume">
                                    {t("I'd like to try another perfume")}
                                </option>
                                <option value="other">
                                    {t("other")}
                                </option>
                            </select>
                            <div className="absolute top-[65%] left-0 transform -translate-y-[40%] flex items-center px-2 pointer-events-none">
                                <FaChevronDown className="text-gray-400" />
                            </div>
                            {formik.touched.reason && formik.errors.reason ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.reason}
                                </div>
                            ) : null}
                        </div>

                        {showOtherFields && (
                            <div className="relative w-full">
                                <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                    {t("other")}
                                </label>
                                <input
                                    type="text"
                                    name="others"
                                    value={formik.values.others}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    className="form-input w-full text-right placeholder-right border border-gray-400 p-2"
                                    placeholder={t("other")}
                                />
                                {formik.touched.others && formik.errors.others ? (
                                    <div className="text-red-500 text-sm mt-1 text-right">
                                        {formik.errors.others}
                                    </div>
                                ) : null}
                            </div>
                        )}

                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("select-province")}
                            </label>
                            <Select
                                name="province"
                                options={provinceOptions}
                                value={provinceOptions.find(option => option.value === formik.values.province)}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("province", selectedOption.value);
                                    formik.setFieldValue("city", "");
                                    const filteredCities = citiesByProvince[selectedOption.value] || [];
                                    setCityOptions(
                                        filteredCities.map(city => ({
                                            value: city.value,
                                            label: city.labelAr
                                        }))
                                    );
                                }}
                                styles={customStyles}
                                placeholder={t("select-province")}
                            />
                        </div>

                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("select-city")}
                            </label>
                            <Select
                                name="city"
                                options={cityOptions}
                                value={cityOptions.find(option => option.value === formik.values.city)}
                                onChange={(selectedOption) => {
                                    formik.setFieldValue("city", selectedOption.value);
                                }}
                                styles={customStyles}
                                placeholder={t("select-city")}
                                isDisabled={!formik.values.province}
                            />
                            {formik.touched.city && formik.errors.city ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.city}
                                </div>
                            ) : null}
                        </div>

                        <div className="relative w-full">
                            <label className="text-sm text-gray-600 mr-2 flex justify-end">
                                {t("address")}
                            </label>
                            <textarea
                                name="address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                className="form-textarea w-full text-right placeholder-right border border-gray-400 p-2 h-20 resize-none"
                                placeholder={t("address")}
                            />
                            {formik.touched.address && formik.errors.address ? (
                                <div className="text-red-500 text-sm mt-1 text-right">
                                    {formik.errors.address}
                                </div>
                            ) : null}
                        </div>
                    </div>

                    <div className="text-left mt-6">
                        <button
                            disabled={loading}
                            type="submit"
                            className={`bg-black text-white py-2 px-4 rounded ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
                        >
                            {t("complete-refund-request")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};